import * as analytics from '@vercel/analytics'
import * as speed from '@vercel/speed-insights'
import * as barChart from '#admin/elements/charts/elements/bar'
import * as pieChart from '#admin/elements/charts/elements/pie'

export const vercel = {
  /** Inject Vercel Analytics & Speed Insights, iif production. */
  setup() {
    if (import.meta.env.PROD) {
      analytics.inject({ mode: 'production' })
      speed.injectSpeedInsights()
    }
  },
}

export const elements = {
  /** Register custom elements in the application. */
  register() {
    pieChart.register()
    barChart.register()
  },
}
